import React, { useState } from 'react';
import { useSingleEffect } from 'react-haiku';
import { useRequest } from 'hooks';

import { Title } from 'components/Misc/Typography';
import { Form, Input, Button } from 'components/Misc/Form';

import { useMeProfileStore } from 'store/me/useMeProfileStore';

const Password = ({ tab, setTab }) => {
	// Set tab on load
	useSingleEffect(() => setTab(tab));

	// Use user's profile store
	const id = useMeProfileStore(state => state.user.id);

	// Store request
	const [[progress], request] = useRequest('put', `users/${id}`);

	// Cache user's data
	const [data, setData] = useState({
		password: '',
		passwordNew: '',
		passwordRepeat: ''
	});

	// Handles input's onChange event
	// @event: object | onChange event
	const onChange = ({ name, value }) => {
		setData(prev => ({
			...prev,
			[name]: value,
		}));
	};

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = async event => {
		event.preventDefault();

		// Do not submit if request in progress
		if (progress) return;

		// Create formdata's instance
		const formdata = new FormData();

		// Append all plain text data as stringified object
		formdata.append('data', JSON.stringify(data));

		// Try to update user's data
		const [success, error] = await request(formdata, { related: 'password' });

		// Update user's data
		if (success) return setData(prev => ({
			...prev,
			password: '',
			passwordNew: '',
			passwordRepeat: ''
		}));

		// TODO: Think of a better way of handling errors
		if (error) console.log(error);
	};

	return (
		<Form
			onSubmit={onSubmit}
			className="mt-4 p-4 grid md:grid-cols-2 gap-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			<Title
				title="Mainīt paroli"
				className="md:col-span-2 text-xl"
			/>

			<Input
				type="password"
				name="password"
				label="Esoša parole"
				value={data.password}
				onChange={onChange}
			/>

			<div className="hidden md:block" />
			
			<Input
				type="password"
				name="passwordNew"
				label="Jaunā parole"
				value={data.passwordNew}
				onChange={onChange}
			/>

			<Input
				type="password"
				name="passwordRepeat"
				label="Jaunā parole atkārtoti"
				value={data.passwordRepeat}
				onChange={onChange}
			/>

			<div className="md:col-span-2 flex justify-end">
				<Button
					submit
					icon="done"
					value="Saglabāt"
					theme="success"
					progress={progress}
				/>
			</div>
		</Form>
	);
};

export default Password;
